<template>
  <div class="page_cashFlow">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex aic">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="88px" size="small" v-if="activeName!=5">
            <el-form-item label="账户名称:">
              <el-select v-model="listQuery.accountName" placeholder="" size="small" style="width: 180px;" clearable filterable>
                <el-option v-for="(item, index) in payCompList" :key="index" :label="item.comp" :value="item.comp"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="银行账号">
              <el-input v-model="listQuery.accountNo" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="日期" v-if="activeName=='2'">
              <el-date-picker v-model="listQuery.recordDate" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="收支类型" v-if="activeName == '0' || activeName == '1'">
              <el-select v-model="listQuery.busiType" placeholder="" filterable style="width:180px">
                <el-option label="全部" :value="0"></el-option>
                <el-option label="项目收入" :value="1"></el-option>
                <el-option label="项目支出" :value="2"></el-option>
                <el-option label="往来收入" :value="3"></el-option>
                <el-option label="往来收入" :value="4"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <el-form :inline="true" :model="listQuery2" class="re_down_form" label-width="88px" size="small" v-if="activeName==5">
            <el-form-item label="账户名称:">
              <el-select v-model="listQuery2.accountName" placeholder="" size="small" style="width: 140px;" clearable filterable>
                <el-option v-for="(item, index) in payCompList" :key="index" :label="item.comp" :value="item.comp"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="银行账号">
              <el-input v-model="listQuery2.accountNo" size="small" clearable style="width:140px"></el-input>
            </el-form-item>
            <el-form-item label="交易开始日期" label-width="100px">
              <el-date-picker v-model="listQuery.startTime" type="date" value-format="yyyy-MM-dd" size="small" style="width: 140px;">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="交易结束日期" label-width="100px">
              <el-date-picker v-model="listQuery.endTime" type="date" value-format="yyyy-MM-dd" size="small" style="width: 140px;">
              </el-date-picker>
            </el-form-item>
          </el-form>
          <div class="screenInput" v-if="activeName == '0' || activeName == '1'">
            <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
              <i class="i_txt" @click="dropDownScreen">{{ showDropScreen == 1 ? '收起' : '更多' }}<i class="el-icon-caret-bottom"></i></i>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="top-right">
        <el-button v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <!-- 筛选下拉框 -->
    <div class="r_dropDownScreen" v-show="showDropScreen == 1 && (activeName == '0' || activeName == '1')">
      <div class="pro_down_box" style="padding-left: 25px;">
        <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="90px" size="small">
          <!-- <el-form-item label="开户行">
            <el-input v-model="listQuery.openingBank" size="small" clearable style="width:180px"></el-input>
          </el-form-item> -->
          <el-form-item label="开始时间">
            <el-date-picker v-model="listQuery.startTradeDate" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间">
            <el-date-picker v-model="listQuery.endTradeDate" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="项目名称">
            <el-select v-model="listQuery.project" placeholder="" style="width:180px" filterable clearable>
              <el-option v-for="item in projectList" :key="item.Id" :label="item.StrprojectName" :value="item.StrprojectName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="对方户名">
            <el-input v-model="listQuery.reciprocalAccountName" size="small" clearable style="width:180px"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="drop-footer">
        <el-button size="small" plain @click="resetHandle()">清空</el-button>
        <el-button size="small" type="info" plain @click="showDropScreen = -1">关闭</el-button>
        <el-button v-preventReClick size="small" type="success" @click="searchHandle()">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>收支</el-breadcrumb-item>
          <el-breadcrumb-item>结算</el-breadcrumb-item>
          <el-breadcrumb-item>{{ tabName }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <el-tabs v-model="activeName" type="card" @tab-click="changeTab">
          <el-tab-pane label="银行流水" name="0" v-if="checkPermission(['bankStatement'], permissionLists)"></el-tab-pane>
          <el-tab-pane label="资金报表" name="1" v-if="checkPermission(['fundsReport'], permissionLists)"></el-tab-pane>
          <el-tab-pane label="银行余额" name="2" v-if="checkPermission(['bankBalance'], permissionLists)"></el-tab-pane>
          <el-tab-pane label="对账单" name="3"></el-tab-pane>
          <el-tab-pane label="导入记录" name="4" v-if="checkPermission(['importRecord'], permissionLists)"></el-tab-pane>
          <el-tab-pane label="AI小杰获取记录" name="5"></el-tab-pane>
        </el-tabs>

        <div class="ftabBtn flex">
          <el-button type="primary" size="small" @click="expList" :loading="isExping" v-if="activeName!='4'">导出</el-button>
          <el-button type="primary" size="small" v-if="activeName == '0'" @click="importBankStatement">导入</el-button>
          <el-button type="warning" size="small" v-if="activeName == '1'" @click="importCustomize">导入定制格式</el-button>
          <el-button type="primary" size="small" @click="expStatement('E2GetBusiBankStatePageList')" :loading="isExping2" v-if="activeName=='1'">银行流水列表导出定制01</el-button>
          <el-button type="primary" size="small" @click="expStatement('E3GetBusiBankStatePageList')" :loading="isExping2" v-if="activeName=='1'">银行流水列表导出定制02</el-button>
          <el-button type="success" size="small" v-if="activeName == '0'" @click="signHandle">人工登记</el-button>
          <el-button type="success" size="small" v-if="activeName == '1'" @click="sendReport">发送报表</el-button>
          <el-button type="danger" size="small" v-if="activeName == '1'" @click="syncHandle" :loading="isSyncing">同步流水</el-button>
          <el-button type="warning" size="small" v-if="activeName == '2'" @click="toChart">趋势图</el-button>
          <el-button type="success" size="small" v-if="activeName == '2'" @click="startUpdate">更新余额</el-button>
        </div>
        <div>
          <div class="sumItem" v-if="activeName == '0'  || activeName == '1'">
            <span class="sumTitle">{{activeName == '0' ? '到款合计' : '净现金流：' }}</span>
            <span class="sumNum">￥{{ formatNumber(sumData.netCashFlow) }}</span>
            <span class="sumTitle">（其中收入：项目</span>
            <span class="sumNum">￥{{ formatNumber(sumData.sumProjectIncome) }}</span>
            <span class="sumTitle"> | 往来 </span>
            <span class="sumNum">￥{{ formatNumber(sumData.sumCurrentIncome) }}</span>
            <span class="sumTitle"> | 其他 </span>
            <span class="sumNum">￥{{ formatNumber(sumData.sumOtherIncome) }}</span>，
            <span class="sumTitle"> 支出：项目 </span>
            <span class="sumNum">￥{{ formatNumber(sumData.sumProjectExpend) }}</span>
            <span class="sumTitle"> | 往来 </span>
            <span class="sumNum">￥{{ formatNumber(sumData.sumCurrentExpend) }}</span>
            <span class="sumTitle"> | 其他</span>
            <span class="sumNum">￥{{ formatNumber(sumData.sumOtherExpenses) }}</span>
            ）
          </div>
          <div class="sumItem" v-if="activeName == '1'"> 资金余额： <span class="sumNum">￥{{ formatNumber(sumBalance) }}</span></div>
          <div class="sumItem" v-if="activeName == '2'">{{  totalCount + '个账户最新统计：余额' }} <span class="sumNum">￥{{ formatNumber(balanceData.balance) }}</span>
            <span class="sumTitle"> | 可用余额</span>
            <span class="sumNum">￥{{ formatNumber(balanceData.availablBalance) }}</span>
            <span class="sumTitle"> | 项目应发未发到款金额</span>
            <span class="sumNum">￥{{ formatNumber(balanceData.proBelongsShould) }}</span>
          </div>
        </div>
        <el-table :data="tableData" border class="doc_table" @selection-change="handleSelectionChange" :max-height="tableHeight - 100" v-loading="loading" style="width:100%">
          <el-table-column key="mul" type="selection" width="55" align="center" fixed="left"></el-table-column>
          <template v-if="activeName == '0' || activeName == '1'">
            <el-table-column prop="tradeDate" key="1" :label="activeName == '0' ? '交易日期' : '报表日期'" min-width="150" :show-overflow-tooltip="true" align="center" v-if="activeName == '0'">
              <template slot-scope="{row}">{{ row.tradeDate ? row.tradeDate.replace('T', ' ') : '' }}</template>
            </el-table-column>
            <el-table-column prop="accountName" key="2" label="账户名称" min-width="160" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="accountNo" key="3" label="银行账号" min-width="160" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="serviceCenter" key="4" label="分公司/服务中心" min-width="140" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="project" key="5" label="项目/部门" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="reciprocalAccountName" key="6" label="对方名称" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="remark" key="7" label="备注" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="incurredAmount" key="7.1" label="交易金额" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="tradingDirec" key="7.2" label="交易方向" min-width="100" :show-overflow-tooltip="true" align="center">
              <template slot-scope="{row}">{{ row.tradingDirec ? '到款' : '付款' }}
              </template>
            </el-table-column>
            <el-table-column prop="attrstatus" key="7.3" label="状态" min-width="100" :show-overflow-tooltip="true" align="center">
              <template slot-scope="{row}">{{ row.attrstatus == 1 ? '未认领' : row.attrstatus == 2 ? '无需认领' :
                row.attrstatus == 3
                  ? '已人工认领' : row.attrstatus == 4 ? '已自动认领' : row.attrstatus == 5 ? '自动认领(非CBS)' : '' }}
              </template>
            </el-table-column>
            <el-table-column prop="incoExpType" key="7.4" label="收支类型" min-width="100" :show-overflow-tooltip="true" align="center">
              <template slot-scope="{row}">{{ row.incoExpType == 1 ? '其他支出' : row.incoExpType == 2 ? '其他收入' :
                row.incoExpType == 3 ? '往来支出' : row.incoExpType == 4 ? '往来收入' : row.incoExpType == 5 ? '项目收入' :
                  row.incoExpType == 6 ? '项目支出' : '' }}
              </template>
            </el-table-column>
            <!-- <el-table-column prop="currentIncome" key="8" label="往来收入" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="currentExpend" key="9" label="往来支出" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column> -->
            <el-table-column prop="balance" key="10" label="交易后账号余额" min-width="140" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="amountClaimed" key="11" label="项目已认领金额" min-width="140" :show-overflow-tooltip="true" align="center">
            </el-table-column>

            <el-table-column prop="openingBank" key="12" label="对方开户行" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="counterCard" key="13" label="对方账户" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="transactionNum" key="14" label="交易流水号" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="summary" key="15" label="交易摘要" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="createMode" key="16" label="创建方式" min-width="100" :show-overflow-tooltip="true" align="center">
              <template slot-scope="{row}">{{ row.createMode == 1 ? 'CBS' : row.createMode == 2 ? '流水导入' :
                row.createMode == 3
                  ? '人工登记' : '' }}
              </template>
            </el-table-column>
            <el-table-column prop="createTime" key="17" label="创建时间" min-width="160" :show-overflow-tooltip="true" align="center">
              <template slot-scope="{row}">{{ row.createTime ? row.createTime.replace("T",' ') : '' }}</template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" align="center" width="200">
              <template slot-scope={row}>
                <div class="injuryTabBtn">
                  <el-button type="text" size="small" v-if="row.attrstatus == 1" @click="claimHandle(row, 4, '认领')">认领</el-button>
                  <el-button type="text" size="small" v-if="row.attrstatus == 1" @click="claimHandle(row, 2, '无需认领')">无需认领</el-button>
                  <el-button type="text" size="small" v-if="row.attrstatus == 2" @click="claimHandle(row, 1, '需要认领')">需要认领</el-button>
                  <el-button type="text" size="small" v-if="row.attrstatus == 3 || row.attrstatus == 4 || row.attrstatus == 5" @click="claimHandle(row, 5, '撤销认领')">撤销认领</el-button>
                  <el-button type="text" size="small" v-if="row.attrstatus != 1" @click="editHandle(row)">编辑</el-button>
                  <el-button type="text" size="small" v-if="row.createMode == 1" @click="downReceipt(row)">回单</el-button>
                  <!-- <el-button type="text" size="small">原始导入表</el-button> -->
                  <el-button type="text" size="small" v-if="row.attrstatus == 1 || row.attrstatus == 2 || row.createMode == 2 || row.createMode == 3" @click="claimHandle(row, 3, '作废')">作废</el-button>
                </div>
              </template>
            </el-table-column>
          </template>
          <template v-if="activeName == '2'">
            <el-table-column prop="accountName" key="2" label="账户名称" min-width="160" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="accountNo" key="3" label="银行账号" min-width="160" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="accountType" key="4" label="账号类型" min-width="100" :show-overflow-tooltip="true" align="center">
              <template slot-scope="{row}">
                {{  row.accountType == 1 ? '主体账户' : row.accountType == 2 ? '合作账户' : '' }}
              </template>
            </el-table-column>
            <el-table-column prop="balance" key="5" label="余额" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="proBelongsShould" key="6" label="属于项目应发未发到款金额" min-width="180" :show-overflow-tooltip="true" align="center">
              <template slot-scope="{row}">
                <span class="blueName cp" v-if="row.proBelongsShould" @click="getDtl(row)">{{ row.proBelongsShould }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="availablBalance" key="7" label="可用余额" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="balanceUpdateTime" key="8" label="最近一笔交易时间" min-width="140" :show-overflow-tooltip="true" align="center">
              <template slot-scope="{row}">{{ row.balanceUpdateTime ? row.balanceUpdateTime.replace('T',' ') : '' }}</template>
            </el-table-column>
            <el-table-column prop="updataTime" key="9" label="更新时间" min-width="140" :show-overflow-tooltip="true" align="center">
              <template slot-scope="{row}">{{ row.updataTime ? row.updataTime.replace('T',' ') : '' }}</template>
            </el-table-column>
          </template>

          <template v-if="activeName == '3'">
            <el-table-column prop="accountName" key="1" label="账户名称" min-width="160" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="bankName" key="2" label="开户行" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="accountNo" key="3" label="银行账号" min-width="160" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="month" key="4" label="对账单月份" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="createTime" key="7" label="获取时间" min-width="140" :show-overflow-tooltip="true" align="center">
              <template slot-scope="{row}">{{ row.createTime ? row.createTime.replace('T',' ') : '' }}</template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" min-width="100" :show-overflow-tooltip="true" align="center">
              <template slot-scope={row}>
                <div class="injuryTabBtn">
                  <el-button type="text" size="small" @click="down(row.url1)">下载1</el-button>
                  <el-button type="text" size="small" @click="down(row.url2)">下载2</el-button>
                </div>
                 
              </template>
            </el-table-column>
          </template>

          <template v-if="activeName == '4'">
            <el-table-column prop="accountName" key="2" label="账户名称" min-width="160" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="importData" key="3" label="导入时间" min-width="160" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="importState" key="4" label="导入状态" min-width="100" :show-overflow-tooltip="true" align="center">
              <template slot-scope="{row}">{{ row.importState == '1' ? '导入成功' : row.importState == '2' ? '删除' : ''
              }}</template>
            </el-table-column>
            <el-table-column prop="importUserNmae" key="5" label="导入人" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="templateType" key="6" label="导入表类型" min-width="100" :show-overflow-tooltip="true" align="center">
              <template slot-scope="{row}">{{ row.templateType == '1' ? '标准格式' : row.templateType == '2' ? '银行原表' :
                row.templateType == '3' ? '合作账户' : '' }}</template>
            </el-table-column>
            <el-table-column prop="fileUrl" key="18" label="原始单" min-width="160" :show-overflow-tooltip="true" align="center">
              <template slot-scope="{row}">
                <div class="blueName cp" @click="down(row.fileUrl)">
                  下载
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="delTime" key="8" label="删除时间" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column label="操作" fixed="right" min-width="100" :show-overflow-tooltip="true" align="center">
              <template slot-scope={row}>
                <div class="injuryTabBtn">
                  <el-button type="text" size="small" @click="delRecord(row)">作废</el-button>
                </div>
              </template>
            </el-table-column>
          </template>

          <template v-if="activeName == '5'">
            <el-table-column prop="createTime" key="1" label="获取时间" min-width="160" :show-overflow-tooltip="true" align="center">
              <template slot-scope="{row}">{{ row.createTime ? row.createTime.replace('T',' ') : '' }}</template>
            </el-table-column>
            <el-table-column prop="accountName" key="2" label="账户名称" min-width="180" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="accountNo" key="3" label="银行账号" min-width="140" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="openBankName" key="4" label="开户行" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="name" key="5" label="交易流水" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column key="6" label="交易时间范围" min-width="200" :show-overflow-tooltip="true" align="center">
              <template slot-scope="{row}">
                <div v-if="row.startTime && row.endTime">
                  {{row.startTime.replace('T',' ') }}至{{  row.endTime.replace('T',' ') }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="name" key="7" label="是否导入" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column label="操作" fixed="right" min-width="140" :show-overflow-tooltip="true" align="center">
              <template slot-scope={row}>
                <div class="injuryTabBtn">
                  <el-button type="text" size="small" @click="GetAccountNotransaction(row)">获取</el-button>
                  <el-button type="text" size="small" @click="getCaptureDtl(row)">明细</el-button>
                  <el-button type="text" size="small">导入</el-button>
                </div>
              </template>
            </el-table-column>
          </template>
        </el-table>

        <div class="block">
          <el-pagination v-if="totalCount > 0 && activeName!=4" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>

        <div class="block">
          <el-pagination v-if="totalCount > 0 && activeName==4" @current-change="currentChange" :current-page.sync="listQuery.pageModel.page" :page-size="Number(listQuery.pageModel.rows)" @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog :title="claimName" :visible.sync="showClaim" width="900px" class="res_dialog enter_dialog">
      <el-form :rules="rules" :inline="true" ref="claimForm" :model="claimForm" class="" label-width="100px" size="mini">
        <el-form-item label="对方户名">
          <div class="formItem">{{ claimInfo.reciprocalAccountName }}</div>
        </el-form-item>
        <el-form-item label="我方户名">
          <div class="formItem">{{ claimInfo.accountName }}</div>
        </el-form-item>
        <el-form-item label="银行流水号">
          <div class="formItem">{{ claimInfo.transactionNum }}</div>
        </el-form-item>
        <el-form-item label="付款金额">
          <div class="formItem">￥{{ formatNumber(claimInfo.incurredAmount) }}</div>
        </el-form-item>
        <el-form-item label="付款时间">
          <div class="formItem">{{ claimInfo.tradeDate.replace('T', ' ') }}</div>
        </el-form-item>
        <template v-if="claimForm.busiType == 4">
          <div>
            <el-form-item label="归属" prop="name">
              <el-radio-group v-model="claimBelong" @change="changeBelong">
                <el-radio label="1">项目</el-radio>
                <el-radio label="2">部门</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
          <el-form-item label="归属项目:" prop="projectId" v-if="claimBelong == '1'">
            <el-select v-model="claimForm.projectId" placeholder="" style="width:300px" filterable clearable>
              <el-option v-for="item in projectList" :key="item.Id" :label="item.StrprojectName" :value="item.Projectid"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="归属部门" prop="depName" v-if="claimBelong == '2'">
            <el-cascader v-model="claimDepartment" ref="depart1" :props="props" filterable :show-all-levels="false" placeholder="请选择部门" :options="departList" @change="handleSectionChange1" size="small" style="width:300px"></el-cascader>
          </el-form-item>
          <el-form-item label="归属月:" prop="attrMonth">
            <el-date-picker v-model="claimForm.attrMonth" value-format="yyyy-MM" type="month" size="small" placeholder="" style="width:300px"></el-date-picker>
          </el-form-item>
        </template>
        <div>
          <el-form-item label="备注:">
            <el-input v-model="claimForm.remark" size="small" type="textarea" rows="4" clearable style="width:300px"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showClaim = false" size="small">取消</el-button>
        <el-button type="primary" :loading="isBtnLoading" v-preventReClick @click="confirmClaim" size="small">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="signName" :visible.sync="showSign" width="900px" class="res_dialog enter_dialog">
      <el-form :rules="rules" :inline="true" ref="signForm" :model="signForm" class="" label-width="100px" size="small">
        <el-form-item label="交易方向" prop="tradingDirec">
          <el-select v-model="signForm.tradingDirec" placeholder="" style="width:300px" filterable clearable>
            <el-option label="到款" :value="true"></el-option>
            <el-option label="付款" :value="false"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="交易金额" size="small" prop="incurredAmount">
          <el-input v-model="signForm.incurredAmount" size="small" clearable style="width:300px"></el-input>
        </el-form-item>
        <el-form-item label="银行流水号" size="small" prop="transactionNum">
          <el-input v-model="signForm.transactionNum" size="small" clearable style="width:300px"></el-input>
        </el-form-item>
        <el-form-item label="我方户名:">
          <el-select v-model="signForm.accountName" placeholder="" size="small" style="width: 300px;" clearable filterable @change="changePayComp">
            <el-option v-for="(item, index) in payCompList" :key="index" :label="item.comp" :value="item.comp"></el-option>
          </el-select>
        </el-form-item>
        <div>
          <el-form-item label="我方银行帐号:">
            <el-radio :label="bank.Account" v-for="bank in BankAccount" :key="bank.Account" style="margin-bottom: 10px;" v-model="signForm.accountNo" @input="(val) => { inputChange(val, bank.OpeningBank, 'openingBank') }">开户行：{{
                bank.OpeningBank }} 帐号：{{
                bank.Account
              }}</el-radio>
            <span v-if="BankAccount.length == 0 && signForm.PayComp">暂无银行帐户</span>
          </el-form-item>
        </div>
        <el-form-item label="对方户名:">
          <el-select v-model="signForm.reciprocalAccountName" placeholder="" size="small" style="width: 300px;" clearable filterable @change="changeReceiveComp">
            <el-option v-for="(item, index) in receiveCompList" :key="index" :label="item.comp" :value="item.comp"></el-option>
          </el-select>
        </el-form-item>
        <div>
          <el-form-item label="对方银行帐号:">
            <el-radio :label="bank.Account" v-for="bank in BankAccount2" :key="bank.Account" style="margin-bottom: 10px;" v-model="signForm.counterCard" @input="(val) => { inputChange(val, bank.OpeningBank, 'otherBank') }">开户行：{{
                bank.OpeningBank }} 帐号：{{
                bank.Account
              }}</el-radio>
          </el-form-item>
        </div>

        <el-form-item label="归属">
          <div class="formItem">
            <el-radio-group v-model="claimBelong" @change="changeBelong">
              <el-radio label="1">项目</el-radio>
              <el-radio label="2">部门</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>
        <el-form-item label="归属项目:" prop="projectId" v-if="claimBelong == '1'">
          <el-select v-model="signForm.projectId" placeholder="" style="width:300px" filterable clearable>
            <el-option v-for="item in projectList" :key="item.Id" :label="item.StrprojectName" :value="item.Projectid"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="归属部门" prop="depName" v-if="claimBelong == '2'">
          <el-cascader v-model="claimDepartment" ref="depart1" :props="props" filterable :show-all-levels="false" placeholder="请选择部门" :options="departList" @change="handleSectionChange1" size="small" style="width:300px"></el-cascader>
        </el-form-item>
        <el-form-item label="归属月:" prop="attrMonth">
          <el-date-picker v-model="signForm.attrMonth" value-format="yyyy-MM" type="month" size="small" placeholder="" style="width:300px"></el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showSign = false" size="small">取消</el-button>
        <el-button type="primary" :loading="isBtnLoading" v-preventReClick @click="confirmSign" size="small">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="导入银行流水信息" :visible.sync="showBankStatement" width="500px">
      <el-form :model="bankForm" ref="bankForm" :rules="rules" label-width="100px">
        <el-form-item label="导入表" prop="templateType">
          <el-radio-group v-model="bankForm.templateType">
            <el-radio :label="1">标准格式</el-radio>
            <el-radio :label="2">银行原表</el-radio>
            <el-radio :label="3">合作账户</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="账户卡号" prop="accountNo">
          <el-input v-model="bankForm.accountNo" @blur="getBankInfo(bankForm.accountNo)" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="开户行" prop="openingBank">
          <el-input v-model="bankForm.openingBank" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="账户名称" prop="accountName">
          <el-input v-model="bankForm.accountName" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="上传文件" prop="fileUrl">
          <el-upload class="upload-demo" action="" :on-remove="handleRemove" multiple :limit="1" :auto-upload="false" :on-exceed="handleExceed" :on-change="handleUpload" accept=".xlsx,.xls" :file-list="fileList">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <!-- <el-form-item label="导入模板下载" prop="name">
          <div style="width:300px">
            <el-button type="text" @click="downBSTemp">下载模板</el-button>
          </div>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showBankStatement = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmImportBankStatement()" :loading="isBtnLoading">确 认</el-button>
      </span>
    </el-dialog>

    <el-dialog title="导入定制格式" :visible.sync="showCustomize" width="500px">
      <el-form :model="bankForm" ref="bankForm" :rules="rules" label-width="100px">
        <el-form-item label="上传文件" prop="fileUrl">
          <el-upload class="upload-demo" action="" :on-remove="handleRemove" multiple :limit="1" :auto-upload="false" :on-exceed="handleExceed" :on-change="handleUpload" accept=".xlsx,.xls" :file-list="fileList">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showCustomize = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmImportCustomize()" :loading="isBtnLoading">确 认</el-button>
      </span>
    </el-dialog>

    <el-dialog title="应发未发到款金额详情" :visible.sync="showDtl" width="1000px">
      <el-table :data="dtlData" border class="doc_table" :max-height="600" style="width:100%">
        <el-table-column prop="accountName" label="账号名称" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="accountNo" label="银行账号" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="bankTransactionDate" label="交易日期" min-width="100" :show-overflow-tooltip="true" align="center">
          <template slot-scope="{row}">{{ row.bankTransactionDate ? row.bankTransactionDate.replace('T',' ') : '' }}</template>
        </el-table-column>
        <el-table-column prop="emainingAvailableCredit" label="可用金额" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="incurredAmount" label="到款金额" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="oppositeName" label="对方户名" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="oppositeAccount" label="对方账号" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="projectName" label="项目名称" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="vestingMonth" label="归属月" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog title="详情" :visible.sync="showDtl2" width="1000px">
      <el-table :data="dtlData2" border class="doc_table" :max-height="600" style="width:100%">
        <el-table-column prop="tradeDate" key="1" label="交易日期" min-width="150" :show-overflow-tooltip="true" align="center">
          <template slot-scope="{row}">{{ row.tradeDate ? row.tradeDate.replace('T', ' ') : '' }}</template>
        </el-table-column>
        <el-table-column prop="accountName" key="2" label="账户名称" min-width="160" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="accountNo" key="3" label="银行账号" min-width="160" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="serviceCenter" key="4" label="分公司/服务中心" min-width="140" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="project" key="5" label="项目/部门" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="reciprocalAccountName" key="6" label="对方名称" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="remark" key="7" label="备注" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="incurredAmount" key="7.1" label="交易金额" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="tradingDirec" key="7.2" label="交易方向" min-width="100" :show-overflow-tooltip="true" align="center">
          <template slot-scope="{row}">{{ row.tradingDirec ? '到款' : '付款' }}
          </template>
        </el-table-column>
        <el-table-column prop="attrstatus" key="7.3" label="状态" min-width="100" :show-overflow-tooltip="true" align="center">
          <template slot-scope="{row}">{{ row.attrstatus == 1 ? '未认领' : row.attrstatus == 2 ? '无需认领' :
                row.attrstatus == 3
                  ? '已人工认领' : row.attrstatus == 4 ? '已自动认领' : row.attrstatus == 5 ? '自动认领(非CBS)' : '' }}
          </template>
        </el-table-column>
        <el-table-column prop="incoExpType" key="7.4" label="收支类型" min-width="100" :show-overflow-tooltip="true" align="center">
          <template slot-scope="{row}">{{ row.incoExpType == 1 ? '其他支出' : row.incoExpType == 2 ? '其他收入' :
                row.incoExpType == 3 ? '往来支出' : row.incoExpType == 4 ? '往来收入' : row.incoExpType == 5 ? '项目收入' :
                  row.incoExpType == 6 ? '项目支出' : '' }}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="currentIncome" key="8" label="往来收入" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="currentExpend" key="9" label="往来支出" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column> -->
        <el-table-column prop="balance" key="10" label="交易后账号余额" min-width="140" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="amountClaimed" key="11" label="项目已认领金额" min-width="140" :show-overflow-tooltip="true" align="center">
        </el-table-column>

        <el-table-column prop="openingBank" key="12" label="对方开户行" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="counterCard" key="13" label="对方账户" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="transactionNum" key="14" label="交易流水号" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="summary" key="15" label="交易摘要" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="createMode" key="16" label="创建方式" min-width="100" :show-overflow-tooltip="true" align="center">
          <template slot-scope="{row}">{{ row.createMode == 1 ? 'CBS' : row.createMode == 2 ? '流水导入' :
                row.createMode == 3
                  ? '人工登记' : '' }}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" key="17" label="创建时间" min-width="160" :show-overflow-tooltip="true" align="center">
          <template slot-scope="{row}">{{ row.createTime ? row.createTime.replace("T",' ') : '' }}</template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
  import {
    create,
    re,
    row
  } from "mathjs";
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  import moment from "moment";
  export default {
    data() {
      return {
        tableHeight: Number(document.body.clientHeight),
        listQuery: {
          pageNumber: 1,
          pageSize: 10,
          startTradeDate: '', //交易日期
          endTradeDate: '',
          busiType: 0, //1为项目收，2项目支出，3为往来收，4为往来支出
          accountName: '',
          accountNo: '',
          openingBank: '',
          serviceCenter: '',
          project: '',
          reciprocalAccountName: '',
          summary: '',
          remark: '',
          // hasGoupCount: '',
          isFinancialState: 0, //1为资金报表
          HasGoupCount: 1,
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
        },
        uploadQuery: {
          name: '',
        },
        bankForm: {
          fileUrl: '',
          templateType: 2, //模版类型1.标准格式 2银行原表 3 合作账户
          openingBank: '',
          accountName: '',
          accountNo: '',
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
        },
        fileList: [],
        showBankStatement: false,
        tabName: '银行流水',
        oldactiveName: '4',
        uploadVisible: false,
        showDropScreen: -1,
        activeName: '0',
        num1: 0,
        tableData: [],
        expandTable: [],
        roletype: localStorage.loginRoletype,
        totalCount: 0,
        loading: false,
        projectList: [], //项目列表
        multipleSelection: [],
        permissionLists: [],
        showClaim: false,
        claimName: '',
        claimBelong: '1', //归属
        props: {
          label: 'strorganname',
          value: 'strorgancode',
          children: 'children',
          checkStrictly: true
        },
        claimDepartment: '',
        isExping: false,
        claimForm: {
          id: '',
          busiType: '',
          attrMonth: '',
          projectId: '',
          depName: '',
          remark: ''
        },
        claimInfo: {
          accountName: '',
          reciprocalAccountName: '',
          transactionNum: '',
          incurredAmount: '',
          tradeDate: '',
        },
        rules: {
          projectId: {
            required: true,
            message: '请选择归属项目',
            trigger: 'change'
          },
          depName: {
            required: true,
            message: '请选择归属部门',
            trigger: 'change'
          },
          attrMonth: {
            required: true,
            message: '请选择归属月',
            trigger: 'change'
          },
          tradingDirec: {
            required: true,
            message: '请选择交易方向',
            trigger: 'change'
          },
          incurredAmount: {
            required: true,
            message: '请输入交易金额',
            trigger: 'change'
          },
          transactionNum: {
            required: true,
            message: '请输入银行流水号',
            trigger: 'change'
          },
          templateType: {
            required: true,
            message: '请选择导入表',
            trigger: 'change'
          },
          openingBank: {
            required: true,
            message: '请输入开户行',
            trigger: 'blur'
          },
          accountName: {
            required: true,
            message: '请输入账户名称',
            trigger: 'blur'
          },
          accountNo: {
            required: true,
            message: '请输入账户卡号',
            trigger: 'blur'
          },
          fileUrl: {
            required: true,
            message: '请上传文件',
            trigger: 'change'
          }
        },
        isBtnLoading: false,
        departList: [], //部门列表
        showSign: false,
        signName: '人工登记',
        signForm: {
          accountName: '',
          accountNo: '',
          openingBank: '',
          tradeDate: "",
          reciprocalAccountName: '',
          counterCard: '',
          otherBank: '',
          tradingDirec: true,
          incurredAmount: 0,
          attrMonth: '',
          projectId: 0,
          depName: '',
          transactionNum: ''
        },
        payCompList: [], //我方公司列表
        receiveCompList: [], //对方
        BankAccount2: [],
        BankAccount: [],
        sumBalance: 0, //资金余额
        sumData: {
          sumProjectIncome: 0, //项目收入
          sumCurrentIncome: 0, //往来收入
          sumOtherIncome: 0, //其他收入
          sumProjectExpend: 0, //项目支出
          sumCurrentExpend: 0, //往来支出
          sumOtherExpenses: 0, //其他支出
          netCashFlow: 0, //净现金流
        },
        balanceData: {
          balance: 0, //余额
          proBelongsShould: 0, //应发未发到款金额
          availablBalance: 0, //可用余额
        },
        dtlData: [],
        showDtl: false,
        fileUrl: "",
        showCustomize: false,
        isExping2: false,
        isSyncing: false,
        permissionLists: [],
        listQuery2: {
          pageModel: {
            rows: 10,
            page: 1,
            orderInput: [{
              property: 'createTime',
              order: 1
            }]
          },
          accountName: '',
          accountNo: '',
          startTime: '',
          endTime: ''
        },
        showDtl2: false,
        dtlData2: [],
      }
    },
    created() {
      this.getButtonPower();
      this.getProList();
      this.getList();
      this.getDepartList();
      this.getlegalsubjectlist();
    },
    methods: {
      checkPermission,
      // 获取按钮权限
      getButtonPower() {
        let that = this
        let butQuery = {
          path: '/cashFlow',
          powerEnName: 'cashFlow'
        }
        xz.getbtnPowerIdBypage(butQuery).then(res => {
          if (res.status == 'ok') {
            let resmsg = res.msg
            if (resmsg) {
              for (let index = 0; index < resmsg.length; index++) {
                let element = resmsg[index];
                that.permissionLists.push(element.Enname);
              }
              console.log(that.permissionLists)
            } else {
              this.permissionLists = []
            }
          } else {
            this.$message.error('获取按钮权限出错')
            this.permissionLists = []
          }
        })
      },
      //获取项目
      getProList() {
        let data = {
          projectname: "", // 项目名称
          projectid: "", // 项目id
          custname: "", //客户名称
          strAchieveowner: "", // 业绩归属人
          strservuserid: "", // 客服
          strBusiStat: "", //项目状态
          strpartner2: "", //合伙人
          perpage: 100000000,
          currpage: 1,
          strorgancode: "",
          roletype: this.roletype,
        }
        xz.getProjectLists(data).then((res) => {
          if (res.status == "ok") {
            this.projectList = res.msg;
          } else {
            this.projectList = [];
          }
        });
      },
      // 获取部门列表
      getDepartList() {
        xz.getorganstr('', '', {
          strIsDisable: ''
        }).then(res => {
          // console.log('部门', res)
          if (res.status == 'ok') {
            if (res.msg && res.msg.parent) {
              this.departList = res.msg.parent[0].children
            }
          } else {
            this.departList = []
          }
        })
      },
      //获取我方和对方账户和开户行
      getlegalsubjectlist() {
        let str = 'GetAdDirectCaymCompanyList'
        xz.AdvanceGetFun(str).then(res => {
          if (res.status == 'ok') {
            this.payCompList = res.data.payCompList;
            this.receiveCompList = res.data.receiveCompList;
          } else {
            this.payCompList = [];
            this.receiveCompList = [];
          }
        })
      },
      currentChange(val) {
        if (this.activeName != '4') {
          this.listQuery.pageNumber = Number(val);
        } else {
          this.listQuery.pageModel.Page = Number(val);
        }
        this.getList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        if (this.activeName != '4') {
          this.listQuery.pageNumber = 1;
          this.listQuery.pageSize = val;
        } else {
          this.listQuery.pageModel.Page = 1;
          this.listQuery.pageModel.rows = val;
        }
        this.getList();
      },
      searchHandle() {
        this.listQuery.pageNumber = 1;
        this.getList();
      },
      changeTab(tab) {
        this.tabName = tab.label;
        if (this.activeName == '4') {
          this.listQuery = {
            pageModel: {
              rows: this.listQuery.pageSize,
              page: this.listQuery.pageNumber,
              orderInput: [{
                order: 1,
                property: "importData"
              }],
            },
            accountName: this.listQuery.accountName,
            accountNo: this.listQuery.accountNo,
            startDate: "",
            endDate: ""
          }

        } else if (this.activeName == '3') {
          this.listQuery = {
            pageModel: {
              rows: this.listQuery.pageSize,
              page: this.listQuery.pageNumber,
              orderInput: [],
            },
            accountName: this.listQuery.accountName,
            accountNo: this.listQuery.accountNo,
            month: "",
          }
        } else if (this.activeName == '2') {
          this.listQuery = {
            pageNumber: 1,
            pageSize: 10,
            accountName: this.listQuery.accountName,
            accountNo: this.listQuery.accountNo,
            recordDate: '',
          }
        } else {
          this.listQuery = {
            pageNumber: 1,
            pageSize: 10,
            startTradeDate: '', //交易日期
            endTradeDate: '',
            busiType: 0, //1为项目收，2项目支出，3为往来收，4为往来支出
            accountName: this.listQuery.accountName,
            accountNo: this.listQuery.accountNo,
            openingBank: '',
            serviceCenter: '',
            project: '',
            reciprocalAccountName: '',
            summary: '',
            remark: '',
            hasGoupCount: '1',
            isFinancialState: 1, //1为资金报表
            userId: Cookies.get("userid-b"),
            roleType: localStorage.loginRoletype,
          }
          if (this.activeName == 1) {
            this.listQuery.isFinancialState = 1;
          } else {
            this.listQuery.isFinancialState = 0;
          }
        }
        this.getList();
      },
      getList() {
        let map = {
          0: 'GetBusiBankStatePageList',
          1: 'GetBusiBankStatePageList',
          2: 'GetBusiBankBalancePageList',
          3: 'GetBillingList',
          4: 'GetBankStateImportLogsPageList',
          5: 'GetAutomaticWaterList',
        }
        let pagename = map[this.activeName]
        let lq = this.activeName != 5 ? this.listQuery : this.listQuery2;
        this.loading = true;
        xz.ArdCurStat(lq, pagename).then(res => {
          if (res.status == 'ok') {
            if (this.activeName != 3 && this.activeName != 4 && this.activeName != 5) {
              this.tableData = res.data.dataList;
              this.totalCount = res.data.totalNumber;
              if (this.activeName == 0) {
                this.sumData = res.data.dataList2[0];
                console.log('this.sumData', this.sumData)
              } else if (this.activeName == 1) {
                this.sumData = res.data.dataList2[0];
                this.sumBalance = res.data.sumBalance;
              } else if (this.activeName == 2) {
                this.balanceData = res.data.dataList2;
              }
            } else {
              this.tableData = res.data.data;
              this.totalCount = res.data.pageModel.totalCount;
            }
            this.loading = false;
          } else {
            this.tableData = [];
            this.totalCount = 0;
            this.loading = false;
          }
        })
      },

      expList() {
        let map = {
          0: 'GetBusiBankStatePageList',
          1: 'GetBusiBankStatePageList',
          2: 'GetBusiBankBalancePageList',
          3: '',
          4: 'GetBankStateImportLogsPageList'
        }
        let pagename = 'E' + map[this.activeName];
        this.isExping = true;
        let d = JSON.parse(JSON.stringify(this.listQuery));
        d.pageSize = 1000000;
        xz.ArdCurStatExp(d, pagename).then(res => {
          if (res) {
            try {
              var data = new Blob([res], {
                type: "application/vnd.ms-excel;charset=utf-8"
              });
              var downloadUrl = window.URL.createObjectURL(data);
              var anchor = document.createElement("a");
              anchor.href = downloadUrl;
              anchor.download = this.tabName + "列表导出.xlsx";
              anchor.click();
              window.URL.revokeObjectURL(data);
              this.isExping = false;
            } catch (e) {
              this.isExping = false;
              this.$message.error('导出异常')
            }
          } else {
            this.isExping = false;
            this.$message.error('导出异常')
          }
        })
      },
      expStatement(pagename) {
        let d = JSON.parse(JSON.stringify(this.listQuery));
        d.pageSize = 1000000;
        xz.ArdCurStatExp(d, pagename).then(res => {
          if (res) {
            try {
              var data = new Blob([res], {
                type: "application/vnd.ms-excel;charset=utf-8"
              });
              var downloadUrl = window.URL.createObjectURL(data);
              var anchor = document.createElement("a");
              anchor.href = downloadUrl;
              anchor.download = `银行流水列表定制导出${moment().format('YYYY-MM-DD')}.xlsx`;
              anchor.click();
              window.URL.revokeObjectURL(data);
              this.isExping = false;
            } catch (e) {
              this.isExping = false;
              this.$message.error('导出异常')
            }
          } else {
            this.isExping = false;
            this.$message.error('导出异常')
          }
        })
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      toDownFile(url) {
        const newWindow = window.open(url, "_blank");
      },
      // 表格多选
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      //导入银行流水信息
      importBankStatement() {
        this.isBtnLoading = false;
        this.fileList = [];
        this.bankForm = this.$options.data.call(this).bankForm;
        this.showBankStatement = true;
      },
      //根据卡号获取银行信息
      getBankInfo(val) {
        if (val) {
          let str = `?AccountNo=${val}`
          xz.ArdCurStatGetFun('GetCardAccountInf', str).then(res => {
            if (res.status == 'ok') {
              this.bankForm.openingBank = res.data.openBank
              this.bankForm.accountName = res.data.accountName
            }
          })
        }
      },
      down(url) {
        var path = this.$store.state.EMP.tablePath + url;
        const aTag = document.createElement("a");
        aTag.href = path;
        aTag.click();
      },
      downHandle(url1, url2) {
        var path = this.$store.state.EMP.tablePath + url1;
        var path2 = this.$store.state.EMP.tablePath + url2;
        const aTag = document.createElement("a");
        aTag.href = path;
        aTag.click();
        const aTag2 = document.createElement("a");
        aTag2.href = path2;
        aTag2.click();
      },
      handleUpload(file) {
        const formData = new FormData();
        formData.append("pagename", "empexcel");
        formData.append("action", "save");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("excel", file.raw, file.name);
        console.log("formData", formData);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            if (this.showBankStatement) {
              this.bankForm.fileUrl = res;
            } else {
              this.fileUrl = res;
            }
          } else {
            this.bankForm.fileUrl = ''
            this.fileUrl = '';
          }
        });
      },
      handleRemove() {
        this.batchForm.userListFile = '';
        this.fileUrl = '';
        this.fileList = [];
      },
      handleExceed() {
        this.$message.warning(`最多上传 1 个文件，请先删除再上传`);
      },
      //趋势图
      toChart() {
        const routerUrl = this.$router.resolve({
          path: "/trendChart"
        });
        const newWindow = window.open(routerUrl.href, "_blank");
      },
      startUpdate() {
        xz.startBalanceUpdate("", this.roletype, 'startBalanceUpdate').then(res => {
          if (res.status == 'ok') {
            this.$message.success('成功！')
          } else {
            this.$message.error(res.msg);
          }
        })
      },
      claimHandle(row, busiType, name) {
        this.claimName = name;
        this.claimForm = {
          id: row.id,
          busiType,
          attrMonth: '',
          projectId: '',
          depName: '',
          remark: ''
        }
        this.claimInfo = row;
        if (busiType != '1') {
          this.isBtnLoading = false;
          this.showClaim = true;
        } else {
          this.confirmClaim()
        }
      },
      // 每三位加逗号
      formatNumber(value) {
        if (!value && value !== 0) return '0';
        return Number(value).toLocaleString();
      },
      //选择归属
      changeBelong() {
        this.claimForm.projectId = '';
        this.claimForm.depName = '';
        this.signForm.projectId = '';
        this.signForm.depName = '';
      },
      //选择部门
      handleSectionChange1() {
        this.$nextTick(() => {
          let depart = this.$refs.depart1.getCheckedNodes()[0];
          this.claimForm.depName = depart.label;
          console.log(depart.label, this.claimForm.Claim.department)
          this.$refs.depart1._data.dropDownVisible = false;
        })
      },
      confirmClaim() {
        this.$refs.claimForm.validate((valid) => {
          if (valid) {
            xz.ArdCurStat(this.claimForm, 'OperatiBankStates').then(res => {
              if (res.status == 'ok') {
                this.$message.success('操作成功！');
                this.getList();
                this.isBtnLoading = false;
                this.showClaim = false;
              } else {
                this.$message.error(res.msg);
                this.getList();
                this.isBtnLoading = false;
              }
            })
          }
        })
      },
      //人工登记
      signHandle() {
        this.signForm = this.$options.data.call(this).signForm;
        this.isBtnLoading = false;
        this.claimDepartment = '';
        this.showSign = true;
      },
      changePayComp(val) {
        if (val) {
          xz.getCompfinanceSet(val, this.roletype).then(res => {
            if (res.status == 'ok') {
              if (!res.data.BankAccountJ) {
                this.BankAccount = []
              } else {
                // 使用 filter 过滤掉 IntPay 为 0 的项
                const filteredBankAccounts = res.data.BankAccountJ.filter(element => element.IntPay !== 0);

                // 设置默认账户和开户行
                filteredBankAccounts.forEach(element => {
                  if (element.IsDefault != undefined && element.IsDefault == '1' && element.IntPay == 1) {
                    this.signForm.accountNo = element.Account;
                    this.signForm.openingBank = element.OpeningBank;
                  }
                });

                this.BankAccount = filteredBankAccounts;
              }
            } else {
              this.BankAccount = [];
            }
          });
        }
      },
      inputChange(val, bank, item) {
        this.signForm[item] = bank;
      },
      changeReceiveComp(val) {
        if (val) {
          xz.getCompfinanceSet(val, this.roletype).then(res => {
            if (res.status == 'ok') {
              if (!res.data.BankAccountJ) {
                this.BankAccount2 = []
              } else {
                res.data.BankAccountJ.forEach(element => {
                  if (element.IsDefault != undefined && element.IsDefault == '1') {
                    this.signForm.counterCard = element.Account
                    this.signForm.otherBank = element.OpeningBank;
                  }
                });
                this.BankAccount2 = res.data.BankAccountJ;
              }
            } else {
              this.BankAccount2 = [];
            }
          })
        }
      },
      //编辑
      editHandle(row) {},
      confirmSign() {
        this.$refs.claimForm.validate((valid) => {
          if (valid) {
            xz.ArdCurStat(this.signForm, 'AddBankStates').then(res => {
              if (res.status == 'ok') {
                this.$message.success('操作成功！');
                this.getList();
                this.isBtnLoading = false;
                this.showSign = false;
              } else {
                this.$message.error(res.msg);
                this.getList();
                this.isBtnLoading = false;
              }
            })
          }
        })
      },
      delRecord(row) {
        let str = `?Id=${row.id}`
        xz.ArdCurStatGetFun('CancelBankStata', str).then(res => {
          if (res.status == 'ok') {
            this.$message.success('操作成功！');
            this.getList();
          } else {
            this.$message.error(res.msg);
            this.getList();
          }
        })
      },
      getDtl(row) {
        let d = {
          accountNo: row.accountNo
        }
        xz.ArdCurStat(d, 'GetDetailsAvailableBalance').then(res => {
          if (res.status == 'ok') {
            this.dtlData = res.data;
            this.showDtl = true;
          } else {
            this.$message.error(res.msg);
            this.dtlData = [];
          }
        })
      },
      getCaptureDtl(row) {
        let str = `?Id=${row.id}&pageNumber=1&pageSize=1000`
        xz.ArdCurStatGetFun('GetutomaticWaterList', str).then(res => {
          if (res.status == 'ok') {
            this.dtlData2 = res.data.dataList;
            this.showDtl2 = true;
          } else {
            this.$message.error(res.msg);
            this.dtlData2 = [];
          }
        })
      },
      sendReport() {
        let str = `?date=${moment().format('YYYY-MM-DD')}`
        console.log(str)
        xz.ArdCurStatGetFun('SubmitFinancialReport', str).then(res => {
          if (res.status == 'ok') {
            this.$message.success('发送成功！')
          } else {
            this.$message.error(res.msg)
          }
        })
      },
      importCustomize() {
        this.fileList = [];
        this.fileUrl = '';
        this.showCustomize = true;
        this.isBtnLoading = false;
      },
      confirmImportCustomize() {
        if (this.fileUrl) {
          this.isBtnLoading = true
          let d = {
            fileUrl: this.fileUrl
          }
          xz.ArdCurStat(d, 'ExporBasicreportCustomize').then(res => {
            if (res.status == 'ok') {
              this.$message.success('导入成功！');
              this.showCustomize = false;
            } else {
              this.$message.error(res.msg)
            }
          })
          this.isBtnLoading = false;
        } else {
          this.$message.error('请上传文件！')
        }
      },
      syncHandle() {
        this.isSyncing = true;
        xz.startBalanceUpdate("", localStorage.loginRoletype, 'StartAddBankState').then(res => {
          if (res.status == 'ok') {
            this.isSyncing = false;
            this.$message.success('成功！')
          } else {
            this.isSyncing = false;
            this.$message.error(res.msg);
          }
        })
      },
      GetAccountNotransaction(row){
        xz.ArdCurStatGetFun('GetAccountNotransaction', `?AccountNo=${row.accountNo}`).then(res => {
          if (res.status == 'ok') {
            this.$message.success('操作成功！');
            this.getList();
          } else {
            this.$message.error(res.msg);
            this.getList();
          }
        })
      },
      confirmImportBankStatement() {
        this.$refs.bankForm.validate((valid) => {
          if (valid) {
            this.isBtnLoading = true;
            xz.AdvanceFun(this.bankForm, 'ImportmportBankStatement').then(res => {
              if (res.status == 'ok') {
                this.isBtnLoading = false;
                this.$message.success('导入成功');
                this.showBankStatement = false;
                this.getBankStatementList();
              } else {
                this.isBtnLoading = false;
                this.$message.error(res.msg);

              }
            })
          }
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .calTitle {
    font-size: 14px;
    font-weight: bold;
  }

  .titleLine {
    font-size: 16px;
    color: #F59A23;
    margin-right: 3px;
  }

  .calList {
    padding-left: 40px;
    margin-top: 20px;
  }

  .calItem {
    margin-bottom: 10px;
  }

  .expandTable {
    padding-left: 50px;
  }

  .formItem {
    width: 300px;
  }

  .sumItem {
    margin-right: 20px;
    font-size: 14px;
    margin-bottom: 5px;
  }

  .sumNum {
    font-weight: 600;
    margin-right: 6px;
    white-space: nowrap;
  }

  .sumTitle {
    white-space: nowrap;
  }
</style>
<style>
  .page_cashFlow .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_cashFlow .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_cashFlow .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_cashFlow .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_cashFlow .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_cashFlow .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }
</style>